import { render, staticRenderFns } from "./ClaimStagingDets.vue?vue&type=template&id=cf94f044&scoped=true&"
import script from "./ClaimStagingDets.vue?vue&type=script&lang=js&"
export * from "./ClaimStagingDets.vue?vue&type=script&lang=js&"
import style0 from "./ClaimStagingDets.vue?vue&type=style&index=0&id=cf94f044&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf94f044",
  null
  
)

component.options.__file = "ClaimStagingDets.vue"
export default component.exports